module.exports = __webpack_public_path__ + "static/Goods-c4d5778fb10cd7b59a5dccf5edaf744b.png";